

import { useNavigate } from 'react-router-dom';
import { CardActionArea, Grid, Card, CardContent, CardMedia, Typography } from '@mui/material';
import { originalTheme } from '../../../theme';



const baseUrl = process.env.REACT_APP_API_URL;



export const CardsCategorias = ({ nombre, id, img, url}) => {


    const navigate = useNavigate();


    const handleVerProductosCategoria = (id) => {
        navigate(`${url}/${ id }`);
    }


    return (
        <Grid item xs={12} sm={10} md={6} >
            <Card  onClick={ () => handleVerProductosCategoria(id) }
                sx={{ width:'100%', height:'240px', borderRadius:'20px', position:'relative',
                    border:`2px solid ${originalTheme.palette.primary.main}`, overflow: 'hidden', 
                    '&:hover .card-content': {opacity: 1, transform:'translateX(-50%) translateY(0)'}
            }}>
                <CardActionArea>
                    <CardMedia component="img" height="240px" alt={nombre}
                        image={`${ baseUrl }/uploads/categorias/${ img }`}
                        sx={{ objectFit: 'cover', }}
                    />
                </CardActionArea>
                <CardContent className="card-content"
                sx={{ position:'absolute', bottom:0, width:'80%', bgcolor:'secondary.main', color:'#fff',
                    display:'flex', justifyContent:'center', alignItems:'center', left:'50%', borderTopLeftRadius:'16px',
                    borderTopRightRadius: '16px', transition:'opacity 0.3s ease, transform 0.3s ease',
                    opacity: {xs: 1, sm: 0}, transform: {xs: 'translateX(-50%)', sm: 'translateX(-50%) translateY(20px)'},
                }}>
                    <Typography variant="h2" sx={{fontSize:25}}>
                        {nombre}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    )
}
